import styled from "styled-components";
import { colors, font, radius, shadow } from "../../../styles/theme/tokens";

const tones = [
  { bg: colors.brandSoft, fg: colors.brandDeep },
  { bg: colors.amberSoft, fg: colors.amberDeep },
  { bg: colors.pinkSoft, fg: colors.pink },
  { bg: colors.successSoft, fg: colors.success },
];

export const Summary = styled.p`
  margin: -4px 0 16px;
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 600;
  color: ${colors.muted};
`;

export const StudentsList = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 14px;
  max-width: 1120px;
  margin: 0;
  padding: 0;
  list-style: none;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const StudentItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 18px;
  font-family: ${font.text};
  background: ${colors.surface};
  border: 1px solid ${colors.line};
  border-radius: ${radius.lg};
  box-shadow: ${shadow.card};
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const StudentAvatar = styled.div`
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 16px;
  font-size: 20px;
  font-weight: 800;
  color: ${({ $tone = 0 }) => tones[$tone].fg};
  background: ${({ $tone = 0 }) => tones[$tone].bg};
`;

export const StudentDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const StudentName = styled.h3`
  margin: 0;
  overflow: hidden;
  font-size: 17px;
  font-weight: 800;
  color: ${colors.ink};
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const Chip = styled.span`
  padding: 2px 10px;
  border-radius: ${radius.pill};
  font-size: 12px;
  font-weight: 700;
  color: ${({ $soft }) => ($soft ? colors.brandDeep : colors.muted)};
  background: ${({ $soft }) => ($soft ? colors.brandSoft : colors.bg)};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 40px;
  padding: 0 4px 0 12px;
  border-radius: ${radius.md};
  background: ${colors.bg};
`;

export const RowLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.muted};
`;

export const LevelValue = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 700;
  color: ${colors.ink};
`;

export const EditBox = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const IconButton = styled.button`
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: ${radius.sm};
  color: ${({ $primary }) => ($primary ? "#FFFFFF" : colors.muted)};
  background: ${({ $primary }) => ($primary ? colors.success : "transparent")};
  cursor: pointer;
  transition: background 0.15s, color 0.15s;

  &:hover {
    color: ${({ $primary }) => ($primary ? "#FFFFFF" : colors.brandDeep)};
    background: ${({ $primary }) => ($primary ? "#128A5A" : colors.brandSoft)};
  }
`;

export const Select = styled.select`
  height: 32px;
  padding: 0 8px;
  border: 1px solid ${colors.line};
  border-radius: ${radius.sm};
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 600;
  color: ${colors.ink};
  background: ${colors.surface};
`;

export const SourceRow = styled.div`
  font-size: 13px;
  color: ${colors.muted};
`;
